module.exports = __webpack_public_path__ + "static/paystack-dashboard-2cd161d52ecac4c03f4d1395a49c19ab.png";